export default __webpack_public_path__ + "static/media/logo.1fe7078e.svg";